import React from "react";
import { usePeopleStore } from "../../../stores/use-people-store";
import DynamicPeople from "../data/DynamicPeople";
import ManualPeople from "../data/ManualPeople";
import { PeopleEditorContainer } from "./styled";
import EditingTabs from "../tabs/EditingTabs";

function PeopleEditor() {
  const { data, selectedTab } = usePeopleStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    setSelectedTab: state.setSelectedTab,
  }));

  const { enrichment } = data.config.tabs[selectedTab] || {};

  return (
    <>
      <PeopleEditorContainer>
        <EditingTabs />
        {enrichment === "dynamic" && <DynamicPeople />}
        {enrichment === "manually" && <ManualPeople isEdit />}
      </PeopleEditorContainer>
    </>
  );
}

export default PeopleEditor;
